import { type BundleConfigOption } from "@jti/fe-common";
import { type MultipleFlavorsSelectorItem } from "@jti/ui/components/MultipleFlavorsSelector";

export const getMixedConsumableFlavors = (option: BundleConfigOption): MultipleFlavorsSelectorItem => {
  const flavorDetails = option.product?.flavorDetails?.[0];

  return {
    id: option.id,
    name: option.product.flavorLabel ?? option.label,
    description: flavorDetails?.description,
    attributes: flavorDetails?.attributes_custom_?.map(({ id, name, sort_order, value }) => ({
      id: +id,
      name,
      sortOrder: +sort_order,
      value,
    })),
    image: {
      url: option.product?.thumbnail?.url,
    },
    brandOptionId: option.product.productBrand ?? undefined,
  };
};
